import { Button, Stack, Box } from "@carrotfertility/carotene-core"
import React, { ReactElement } from "react"
import { FormattedMessage } from "react-intl"
import { Paths } from "#/utils/Paths"
import { useHistory } from "react-router"
import { useContentfulBenefitHighlights } from "#/components/home/benefits-modules/hooks/useContentfulBenefitHighlights"
import { ContentfulContentRenderer } from "#/services/contentful"

export function CalibratedEngagementCta(): ReactElement {
  const history = useHistory()

  return (
    <Stack alignItems={"start"}>
      <Button
        onClick={() => history.push(Paths.YOUR_BENEFIT_GUIDE)}
        color="secondary"
        variant="contained"
        fullWidth={false}
      >
        <FormattedMessage defaultMessage="View benefit guide" />
      </Button>
    </Stack>
  )
}

export function ContentfulBenefitHighlightsContent(): ReactElement {
  const { content, isLoading, isError } = useContentfulBenefitHighlights()

  if (isLoading || isError || !content) {
    return null
  }

  return (
    <Box data-testid="contentful-benefit-highlights">
      <ContentfulContentRenderer contents={content} />
    </Box>
  )
}
